/**
 * The template a Writing paper is imported as, assembled from two prompts.
 *
 * Kept apart from the form so it can be tested as what it is — text going into
 * the importer — and so the importer's own tests can check the same shape.
 */
export const TIMING = {
  1: 'You should spend about 20 minutes on this task. Write at least 150 words.',
  2: 'You should spend about 40 minutes on this task. Write at least 250 words.',
} as const;

export function buildWritingTemplate(input: {
  title: string;
  taskOne: string;
  taskTwo: string;
  imageName: string | null;
}): string {
  const task = (n: 1 | 2, prompt: string, image: string | null) =>
    [
      `@PART ${n}`,
      `instructions: ${TIMING[n]}`,
      '',
      `@GROUP ${n}-${n}`,
      `type: WRITING_TASK_${n}`,
      ...(image ? [`image: ${image}`] : []),
      '@BODY',
      ...prompt.trim().split('\n').map((line) => line.trim()).filter(Boolean),
      '@ENDBODY',
    ].join('\n');

  return [
    '@TEST',
    `title: ${input.title.trim() || 'Writing paper'}`,
    'module: WRITING',
    'variant: ACADEMIC',
    '',
    task(1, input.taskOne, input.imageName),
    '',
    task(2, input.taskTwo, null),
    '',
  ].join('\n');
}

